var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJwt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2500 2550",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    heigh: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "JWT") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h2500v1250h-2500z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m673.8 479.4-.6-168.1h-93.8l.6 168.1 46.9 64.4zm-93.8 288.1v168.7h93.8v-168.7l-46.9-64.4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m673.8 767.5 98.8 136.3 75.6-55-98.8-136.3-75.6-24.4zm-93.8-288.1-99.4-136.3-75.6 55 98.8 136.2 76.2 24.4z",
    fill: "#00f2e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.8 534.4-160-51.9-28.8 88.7 160 52.5 75.6-25zm198.7 113.7 46.9 64.4 160 51.9 28.8-88.7-160-51.9z",
    fill: "#00b9f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m778.1 623.8 160-52.5-28.8-88.7-160 51.9-46.9 64.4zm-303.1 0-160 51.9 28.8 88.7 160-51.9 46.9-64.4z",
    fill: "#d63aff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.8 712.5-98.8 136.3 75.6 55 99.4-136.3v-79.4zm245.6-178.1 98.8-136.3-75.6-55-98.8 136.2v79.4z",
    fill: "#fb015b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1288.1 470.6v218.7c0 48.1-39.4 87.5-87.5 87.5v-43.8c24.4 0 43.8-19.4 43.8-43.8v-218.6zm798.8 43.8h98.7v-43.7h-240.6v43.7h98.1v262.5h43.8zm-273.8-43.8v218.7c0 24.4-19.4 43.8-43.8 43.8s-43.8-19.4-43.8-43.8v-131.2c0-48.1-39.4-87.5-87.5-87.5s-87.5 39.4-87.5 87.5v131.3c0 24.4-19.4 43.8-43.8 43.8s-43.8-19.4-43.8-43.8v-218.8h-43.8v218.7c0 48.1 39.4 87.5 87.5 87.5s87.5-39.4 87.5-87.5v-131.2c0-24.4 19.4-43.8 43.8-43.8s43.8 19.4 43.8 43.8v131.3c0 48.1 39.4 87.5 87.5 87.5s87.5-39.4 87.5-87.5v-218.8z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJwt);
export default __webpack_public_path__ + "static/media/Jwt.a22a3edb3b31f8fc4365110806291b39.svg";
export { ForwardRef as ReactComponent };